import uniq from 'lodash/uniq';
import { createSelector } from 'reselect';

import { Resource, selectIsLoadingByResource } from '../loading';
import type { ApplicationState } from '../types';

export const selectUniqAdjustmentUuids = (state: ApplicationState) =>
  uniq(state.payables.adjustments.map((a) => a.createdBy));

export const selectPayableById = (state: ApplicationState, id: number) =>
  state.payables.byId?.[id];

export const selectIsLoadingPayableById = createSelector(
  [selectIsLoadingByResource],
  (isLoadingByResource) => isLoadingByResource[Resource.PayableById]
);
